import React from "react"
import { navigate } from 'gatsby'
import Logo from '../../static/assets/CbCo.svg'

export default function Logos () {
return (
<img src={Logo} className="dark-logo" width="60px" height="60px" alt="Craft Boxing Co Logo" onClick={() => navigate('/')} style={{cursor:'pointer'}} />
)
}